import React, {useEffect, useState} from "react";
import {
    AdmonitionDirectiveDescriptor, codeBlockPlugin,
    directivesPlugin,
    headingsPlugin, linkPlugin, listsPlugin, markdownShortcutPlugin,
    MDXEditor,
    quotePlugin, tablePlugin, thematicBreakPlugin
} from "@mdxeditor/editor";
import Main from "./Main";
import {Paper} from "@mui/material";

function MarkdownPage({title, file, children}) {
    const [markdown, setMarkdown] = useState('');
    useEffect(() => {
        if (file !== undefined) {
            fetch(file)
                .then(r => r.text())
                .then(mkdwn => {
                    setMarkdown(<MDXEditor markdown={mkdwn} className={'announcement'}  readOnly={true} plugins={[
                        directivesPlugin({directiveDescriptors: [AdmonitionDirectiveDescriptor]}),
                        headingsPlugin(),
                        quotePlugin(),
                        listsPlugin(),
                        tablePlugin(),
                        markdownShortcutPlugin(),
                        linkPlugin(),
                        thematicBreakPlugin(),
                        codeBlockPlugin()
                    ]} />);
                });
        } else {
            setMarkdown('');
        }
    }, [file]);
    return (
        <Main title={title}>
            <Paper elevation={24} sx={{maxWidth: '95vw', width: '1200px', padding: '10px 30px', textAlign: 'left', marginBottom: 2}}>
                {markdown}
                {children}
            </Paper>
        </Main>
    );
}

export default MarkdownPage;